module.exports = __webpack_public_path__ + "img/pubgm.bc236c6.png";